export const ROUTES = {
  home: {
    path: "/",
    title: "Home",
  },
  education: {
    path: "/education",
    title: "Opleiding",
  },
  blog: {
    path: "/blog",
    title: "Blog",
  },
  curriculum: {
    path: "/curriculum",
    title: "Curriculum",
  },
  portfolio: {
    path: "/portfolio",
    title: "Portfolio",
  },
  services: {
    path: "/services",
    title: "Services",
  },
  team: {
    path: "/team",
    title: "Team",
  },
  search: {
    path: "/search",
    title: "Search",
  },
  project: {
    path: "/projects/:slug",
    title: "Project",
  },
  blogpost: {
    path: "/blog/:slug",
    title: "Blogpost",
  },
  service: {
    path: "/services/:slug",
    title: "Service",
  },
};
